import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent } from "vue"

import { RouterView } from 'vue-router';
import { ref, computed, watch, onBeforeUnmount, defineAsyncComponent } from 'vue';
import { useLayout } from '@/composables/useLayout';
import { storeToRefs } from 'pinia';
import { useUserStore } from '@/stores/useUserStore';
import { useLoadingDialogStore } from '@/stores/useLoadingDialogStore';
import { BaseSwal } from '@/plugins/baseSwal';
import { useI18n } from 'vue-i18n';

const ONE_MINUTE = 60 * 1000;


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { layout } = useLayout();
const userStore = useUserStore();
const { r6IsUp, isFirstCheckCheckR6IsUp } = storeToRefs(userStore);
const loadingDialogStore = useLoadingDialogStore();
const { t } = useI18n();

const polling = ref<any>(null);

const layoutComponent = computed(() => layout.value ? defineAsyncComponent(() => import(`@/layouts/${layout.value}.vue`)) : '');

watch(r6IsUp, (val) => {
  if (!val) {
    clearInterval(polling.value);
    onShowR6ApiDownDialog();
  } else {
    pollR6();
  }
});
watch(isFirstCheckCheckR6IsUp, (val) => {
  if (val) {
    pollR6();
  }
});

onBeforeUnmount(() => {
  clearInterval(polling.value);
});

async function checkR6IsUp() {
  await userStore.checkR6IsUp();
}
function pollR6() {
  polling.value = setInterval(() => {
    checkR6IsUp();
  }, ONE_MINUTE);
}
function onShowR6ApiDownDialog() {
  BaseSwal.fire({
    title: t('R6-API-DOWN-HEADLINE'),
    html: t('R6-API-DOWN-TEXT'),
    icon: 'error',
    showCancelButton: true,
    confirmButtonText: t('TRY-AGAIN'),
    cancelButtonText: t('NO-THANKS'),
    customClass: {
      confirmButton: 'text-white !bg-zbr-primary focus:!shadow-border-3-zbr-primary-1/2',
    },
    preConfirm: async() => {
      loadingDialogStore.showDialog(true);
      try {
        await checkR6IsUp();
        if (!r6IsUp.value) {
          return false;
        }
      } finally {
        loadingDialogStore.showDialog(false);
      }
    },
  }).then(async(result) => {
    if (result.isDismissed) {
      logout();
    }
  });
}
async function logout() {
  try {
    await userStore.logout();
    window.location.href = 'https://zbr-hohl.de/';
  } catch (err: any) {
    console.log(err);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_loading_dialog = _resolveComponent("loading-dialog")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(layoutComponent.value), null, {
    default: _withCtx(() => [
      _createVNode(_unref(RouterView), null, {
        default: _withCtx(({ Component }) => [
          _createVNode(_Transition, {
            "enter-active-class": "transition ease-out duration-300",
            "enter-from-class": "opacity-0 transform -translate-y-5",
            "enter-to-class": "opacity-100 transform translate-y-0",
            "leave-active-class": "transition ease-in duration-300",
            "leave-from-class": "opacity-100 transform translate-y-0",
            "leave-to-class": "opacity-0 transform -translate-y-5"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { key: "routerViewSlot" }))
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }),
      _createVNode(_component_loading_dialog)
    ]),
    _: 1
  }))
}
}

})